import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress } from '@mui/material';

import { Menu } from '@components/base';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';

import DistinctByMenuItem from './DistinctByMenuItem';
import ToolbarButton from './ToolbarButton';

const DistinctBy: FC = () => {
  const { t } = useTranslation();

  const {
    searchQuery: { distinctBy },
    isReadonly,
    updateDistinctBy,
    filterDefLoad: { isLoading: filterDefsLoading, data: filterDefs },
  } = useSearchAndFilter();

  return (
    <Menu>
      <ToolbarButton
        disabled={isReadonly}
        isLastItem
        isMenuButton
        rightIcon='chevronDown'
        subtitle={distinctBy}
        title={t('distinctBy')}
      />

      <Menu.Content>
        {filterDefsLoading || !filterDefs ? (
          <Box alignItems='center' display='flex' justifyContent='center' minWidth={160} p={4}>
            <CircularProgress />
          </Box>
        ) : (
          [
            <Menu.Item divider key={0} onClick={() => updateDistinctBy()} selected={!distinctBy}>
              {t('none')}
            </Menu.Item>,
            ...filterDefs.map(filterDef => (
              <DistinctByMenuItem
                filterDef={filterDef}
                handleUpdateDistinctBy={updateDistinctBy}
                key={filterDef.propertyName}
              />
            )),
          ]
        )}
      </Menu.Content>
    </Menu>
  );
};

export default DistinctBy;
